export default __webpack_public_path__ + "media/images/backgrounds/white-strip-2-417b2126b8250be7ce72d61cd743b58a.svg";